import {ref} from 'vue'
import axios from "axios";

export default function useEvents() {
    const events = ref([])
    const event = ref({})
    const errors = ref({})

    const getEvents = async () => {
        let path = window.location.pathname;

        let response = await axios.get(path.replace('catalog', 'catalog/points') + window.location.search)

        events.value = response.data;
    }

    const getEvent = async (slug) => {
        let response = await axios.get('/events/' + slug)

        event.value = response.data;
    }

    const getUniquePromoCode = async () => {
        let response = await axios.post('/promo/get')

        return response.data;
    }

    const sendLeadForm = async (form) => {
        return await axios.post('/events/lead', form).then(function (response) {
            return response.data.success;
        }).catch(error => {
            errors.value = error.response.data.errors;

            return false;
        });
    }

    const sendPartnersForm = async (form) => {
        return await axios.post('/form/partners', form).then(function (response) {
            return response.data.success;
        }).catch(error => {
            errors.value = error.response.data.errors;

            return false;
        });
    }

    return {
        events,
        event,
        errors,
        getEvents,
        getEvent,
        getUniquePromoCode,
        sendPartnersForm,
        sendLeadForm
    }
}
